import { TagsSettings } from './tags-settings';

export { TagsSettings };
